export default __webpack_public_path__ + "static/media/terms-image.9606ae39.jpg";